import styled from 'styled-components'
import { PageHeader } from 'antd'

type Props = {
  docType: 'icnf' | 'lupa'
  changeNavigation: (key?: string) => void
}

const Doc = ({ docType, changeNavigation }: Props) => {
  const url =
    docType === 'lupa'
      ? 'https://cld.pt/dl/download/ab5cfb5d-1e18-4fbf-978f-49500403dee6/manual_lupa.pdf#toolbar=0'
      : 'https://cld.pt/dl/download/ab5cfb5d-1e18-4fbf-978f-49500403dee6/manual_lupa.pdf#toolbar=0'
  return (
    <Container>
      <StyledPageHeader
        onBack={() => changeNavigation(undefined)}
        title={<StyledPageText>Voltar</StyledPageText>}
      />
      <object data={url} type="application/pdf" width="100%" height="100%">
        <p>Ocorreu um erro e não foi possível carregar o ficheiro.</p>
      </object>
    </Container>
  )
}

export default Doc

const Container = styled.div`
  background-color: #ececec;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  max-height: 100%;
  padding: 10px;

  @media (max-width: 768px) {
    padding: 5px;
  }
`
const StyledPageHeader = styled(PageHeader)`
  padding: 0;
`

const StyledPageText = styled.span`
  @media (max-width: 768px) {
    font-size: 12px;
  }
`
